import TextField, { TextFieldProps } from "components/inputs/TextField";
import { modificateRequiredRule } from "helpers/validation/utils";
import { FocusEvent } from "react";
import { useController, UseControllerProps } from "react-hook-form";

export type TextFieldControlProps = {
  name: UseControllerProps["name"];
  rules?: UseControllerProps["rules"];
  onBlurCallback?: (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
} & Omit<TextFieldProps, "onChange">;

const TextFieldControl = ({ name, rules, onBlurCallback, disabled, ...props }: TextFieldControlProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ defaultValue: "", name, rules: modificateRequiredRule(rules), disabled });

  return (
    <TextField
      {...props}
      {...field}
      disabled={disabled}
      onBlur={(event) => {
        field.onBlur();
        onBlurCallback?.(event);
      }}
      error={error}
      required={Boolean(rules?.required)}
    />
  );
};

export default TextFieldControl;
